import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../api";

const F = ({ label, children }) => (
  <div className="mb-3">
    <p className="text-[10px] tracking-widest text-[#B8892B] mb-1">{label}</p>
    {children}
  </div>
);
const inputCls = "w-full bg-[#F3EBDD] border border-[#E5D9BE] rounded-lg px-3 py-2 text-sm text-[#3E2A1A] outline-none focus:border-[#D4AF37]/60";

export const AdminVisits = () => {
  const [data, setData] = useState(null);
  const [form, setForm] = useState(null);
  const load = () => api.get("/admin/loyalty").then((r) => {
    setData(r.data);
    setForm({ reward_item: r.data.reward_item, visits_needed: r.data.visits_needed,
      weekly_surprise: r.data.weekly_surprise, prize_text: r.data.prize_text, rules_text: r.data.rules_text });
  }).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data || !form) return <p className="text-xs text-[#9a8f7c]">Loading…</p>;

  const save = async () => {
    try {
      await api.put("/admin/loyalty", { ...form, visits_needed: Number(form.visits_needed) || 5 });
      toast.success("Saved — live for guests right away");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
  };
  const confirmWinner = async (row) => {
    if (!window.confirm(`Confirm ${row.name} (${row.visits} visits) as this month's winner?`)) return;
    try {
      await api.post("/admin/loyalty/confirm-winner", { phone: row.phone });
      toast.success("Winner confirmed");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not confirm"); }
  };
  const winner = (data.winners || []).find((w) => w.month === data.month);

  return (
    <div data-testid="admin-visits" className="space-y-4">
      <div className="rounded-xl bg-[#FFFDF8] border border-[#E5D9BE] p-4">
        <p className="text-[10px] tracking-widest text-[#B8892B] mb-1">VISIT REWARDS — WHAT GUESTS EARN</p>
        <p className="text-xs text-[#9a8f7c] mb-3">One visit per phone per day, counted when a VeerGi sends the order to the kitchen.</p>
        <div className="grid grid-cols-2 gap-3">
          <F label="REWARD ITEM"><input data-testid="visits-reward-item" className={inputCls} value={form.reward_item} onChange={(e) => setForm({ ...form, reward_item: e.target.value })} /></F>
          <F label="VISITS NEEDED"><input data-testid="visits-needed-input" type="number" min="1" max="50" className={inputCls} value={form.visits_needed} onChange={(e) => setForm({ ...form, visits_needed: e.target.value })} /></F>
        </div>
        <F label="WEEKLY SURPRISE (shown to guests — set it yourself, no automatic draw)">
          <input data-testid="visits-surprise-input" className={inputCls} placeholder="e.g. Friday: a random table wins dessert" value={form.weekly_surprise} onChange={(e) => setForm({ ...form, weekly_surprise: e.target.value })} />
        </F>
        <F label="MONTHLY PRIZE TEXT"><input data-testid="visits-prize-input" className={inputCls} value={form.prize_text} onChange={(e) => setForm({ ...form, prize_text: e.target.value })} /></F>
        <F label="RULES TEXT"><textarea data-testid="visits-rules-input" rows={3} className={inputCls} value={form.rules_text} onChange={(e) => setForm({ ...form, rules_text: e.target.value })} /></F>
        <button data-testid="visits-save-btn" onClick={save} className="rounded-full bg-[#B8892B] text-white text-[10px] font-bold tracking-widest px-5 py-2.5">SAVE</button>
        <span className="ml-4 text-[10px] text-[#9a8f7c]">Chai unlocked: {data.rewards_unlocked} · redeemed: {data.rewards_redeemed}</span>
      </div>

      <div className="rounded-xl bg-[#FFFDF8] border border-[#E5D9BE] p-4">
        <p className="text-[10px] tracking-widest text-[#B8892B] mb-1">THIS MONTH'S LEADERBOARD — {data.month}</p>
        <p className="text-xs text-[#9a8f7c] mb-3">The winner is never automatic. You confirm them here at month's end.</p>
        {winner && (
          <p data-testid="visits-winner-line" className="text-xs font-bold text-green-700 mb-2">
            CONFIRMED WINNER: {winner.name} · {winner.phone} · {winner.prize}
          </p>
        )}
        <div className="divide-y divide-[#EFE5CE]">
          {data.board.map((r) => (
            <div key={r.phone} data-testid={`visits-board-row-${r.rank}`} className="flex items-center gap-3 py-2">
              <span className="w-6 text-center font-bold text-[#9a8f7c]">{r.rank}</span>
              <span className="flex-1 text-xs font-semibold text-[#3E2A1A]">{r.name} <span className="text-[#9a8f7c]">· {r.phone}</span></span>
              <span className="text-sm font-black text-[#B8892B]">{r.visits}</span>
              <button data-testid={`visits-confirm-${r.rank}`} onClick={() => confirmWinner(r)}
                className="text-[9px] font-bold tracking-widest rounded-full border border-[#B8892B]/60 text-[#B8892B] px-3 py-1.5">
                CONFIRM WINNER
              </button>
            </div>
          ))}
          {!data.board.length && <p className="text-xs text-[#9a8f7c] py-2">No visits yet this month.</p>}
        </div>
        {(data.winners || []).length > 0 && (
          <div className="mt-3 pt-3 border-t border-[#EFE5CE]">
            <p className="text-[10px] tracking-widest text-[#9a8f7c] mb-1">PAST CONFIRMED WINNERS</p>
            {data.winners.map((w) => (
              <p key={w.month} className="text-xs text-[#6b5c45]">{w.month}: {w.name} · {w.phone}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
